/* SessionStatusInline.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import { ShimmerText } from '../compact-research-steps/ShimmerText';
import { RovoThinkingIndicator } from '../loading-state/thinking-indicator/ThinkingIndicator';
import { messages } from './messages';
import { SessionStatusIcon, type SessionStatus, type SessionStatusIconSize } from './SessionStatusIcon';
const styles = {
  status: "_3iDTPbccYA _3YEZNOdnbC"
};
export type SessionStatusInlineStatus = SessionStatus | 'thinking' | 'working';
export type SessionStatusInlineProps = {
  status: SessionStatusInlineStatus;
  /** Whether to render the needs-input icon alongside its text. */
  showIcon?: boolean;
  /** Visual size for the needs-input icon. Defaults to 12. */
  iconSize?: SessionStatusIconSize;
  /** Whether the thinking agent is the default Rovo agent. Defaults to true. */
  isDefaultAgent?: boolean;
  /** Text size for the status. Defaults to the regular body size. */
  textSize?: 'default' | 'small';
  testId?: string;
};

/** Renders a compact semantic status suitable for a session-details list. */
export const SessionStatusInline = ({
  status,
  showIcon = true,
  iconSize = 12,
  isDefaultAgent = true,
  textSize = 'default',
  testId
}: SessionStatusInlineProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  if (status === 'working') {
    return <Inline as="span" xcss={styles.status} alignBlock="center" shouldWrap={false} testId={testId}>
				<ShimmerText as="span" size={textSize === 'small' ? 'small' : 'medium'}>
					{formatMessage(messages.working)}
				</ShimmerText>
			</Inline>;
  }
  if (status === 'thinking') {
    return <Inline as="span" xcss={styles.status} alignBlock="center" shouldWrap={false} space="space.050">
				<RovoThinkingIndicator title={formatMessage(isDefaultAgent ? messages.rovoIsThinking : messages.agentIsThinking)} animation icon={false} disableMorphingAnimation showEllipsis={false} textSize={textSize} testId={testId} />
			</Inline>;
  }
  return <Inline as="span" xcss={styles.status} alignBlock="center" shouldWrap={false} space="space.050" testId={testId}>
			{showIcon ? <SessionStatusIcon status={status} iconSize={iconSize} /> : null}
			<Text as="span" size={textSize === 'small' ? 'small' : 'medium'} color="color.text.subtlest">
				{formatMessage(messages.needsInput)}
			</Text>
		</Inline>;
};